import * as types from './mutation-types'

const mutations = {
  [types.SET_ACTIVEHOMEWORK] (state, work) {
    state.activeHomeWork = work
  },
  [types.SET_CLASSLIST] (state, list) {
    state.classList = list
  },
  [types.SET_HISTORYWORKLIST] (state, list) {
    state.historyWorks = list
  },
  [types.SET_STUHOMEWORK] (state, work) {
    state.stuHomeWork = work
  },
  [types.SET_PEERWORKLIST] (state, list) {
    state.peerReviewHomeworkList = list
  },
  [types.SET_PEERTASK] (state, list) {
    state.peerTasks = list
  },
  [types.SET_MARK] (state, list) {
    state.marks = list
  },
  [types.SET_ATTACH] (state, model) {
    state.attach = model
  },
  [types.UPDATELOADINGSTATUS] (state, status) {
    state.isLoading = status.isLoading
  },
  [types.SET_COURSEROLE] (state, model) {
    state.courseRole = model
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js